import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  `,
  pdfWrapper: css`
    width: 100%;
    height: 100%;
  `,
  skeleton: css`
    background-color: white;
    z-index: 1;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
